import { replace } from 'react-router-redux';

export const SIMULATOR_LEFTEAR_SUBMIT = Symbol('SIMULATOR_LEFTEAR_SUBMIT');
export const SIMULATOR_RIGHTEAR_SUBMIT = Symbol('SIMULATOR_RIGHTEAR_SUBMIT');

export function submitLeftEar(points) {
  return dispatch => {
    dispatch({
      type: SIMULATOR_LEFTEAR_SUBMIT,
      points,
    });

    dispatch(replace('/simulators/right-ear'));
  };
}

export function submitRightEar(points) {
  return dispatch => {
    dispatch({
      type: SIMULATOR_RIGHTEAR_SUBMIT,
      points,
    });

    dispatch(replace('/simulators/result'));
  };
}



// WEBPACK FOOTER //
// ./actions/Simulator.js